import { Charger, ValidChargerIds, CableSetup } from "_core/types";

export const getChargerId = (charger: Charger, cableSetup: CableSetup) => {
  if (charger === Charger.ANDERSENA2) {
    return ValidChargerIds.Andersen_A2;
  }

  if (charger === Charger.ANDERSENA3) {
    return ValidChargerIds.Andersen_A3;
  }

  if (charger === Charger.ANDERSENQUARTZ) {
    return ValidChargerIds.Andersen_Quartz;
  }

  if (charger === Charger.HYPERVOLT) {
    return ValidChargerIds.Hypervolt_Tethered;
  }

  if (charger === Charger.INDRA) {
    if (cableSetup === CableSetup.TETHERED)
      return ValidChargerIds.Indra_Smart_PRO_Tethered;
    return ValidChargerIds.Indra_Smart_PRO_Not_Tethered;
  }

  if (charger === Charger.ZAPPIGLOW) {
    return ValidChargerIds.Zappi_GLO;
  }

  if (charger === Charger.ZAPPI21) {
    return ValidChargerIds.Zappi_21;
  }
};
